import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useNavigate } from 'react-router-dom';

const PaymentErrorPage = ({ skipcashStatusId, skipcashStatus, skipcashPaymentId }) => {
  const navigate = useNavigate();

  // Determine error reason
  let reason = 'Unfortunately, your payment was not successful.';
  let details = '';
  if (skipcashStatusId === '3') {
    reason = 'You cancelled the payment process.';
    details = 'No payment was made. You can try again or choose another payment method.';
  } else if (skipcashStatusId === '4') {
    reason = 'Your card was declined or there was an issue processing your payment.';
    details = 'This could be due to insufficient funds, incorrect card details, or a bank restriction.';
  }

  return (
    <div className="payment-error-page" style={{
      minHeight: '100vh',
      background: '#fff',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <Header />
      <main style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{
          background: '#fff',
          padding: '40px 24px',
          maxWidth: 420,
          width: '100%',
          textAlign: 'center'
        }}>
          <div style={{ fontSize: 56, marginBottom: 16 }}>⚠️</div>
          <h1 style={{
            fontSize: 26,
            fontWeight: 800,
            margin: '0 0 10px 0',
            letterSpacing: 0.5,
            color: '#222'
          }}>
            Payment Could Not Be Completed
          </h1>
          <p style={{ color: '#b00020', fontWeight: 600, marginBottom: 8 }}>{reason}</p>
          {details && <p style={{ color: '#555', marginBottom: 16 }}>{details}</p>}

          <div style={{
            background: '#fff',
            padding: '16px 12px',
            margin: '18px 0',
            fontSize: 15,
            color: '#444',
            textAlign: 'left'
          }}>
            <strong>Why did this happen?</strong>
            <ul style={{ margin: '10px 0 0 18px', padding: 0 }}>
              <li>Card declined (insufficient funds, incorrect info, or bank block)</li>
              <li>Payment cancelled before completion</li>
              <li>Network or bank error</li>
            </ul>
            {skipcashPaymentId && (
              <div style={{ fontSize: 13, color: '#888', marginTop: 10 }}>
                Payment Ref: <span style={{ fontFamily: 'monospace' }}>{skipcashPaymentId}</span>
              </div>
            )}
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 12, margin: '18px 0' }}>
            <button
              style={{
                background: '#222',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                padding: '14px 0',
                fontWeight: 700,
                fontSize: 17,
                cursor: 'pointer'
              }}
              onClick={() => navigate('/checkout')}
            >
              Try Again
            </button>
          </div>

          <div style={{ display: 'flex', gap: 10, marginTop: 10 }}>
            <button
              style={{
                background: '#25D366', // WhatsApp green
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                padding: '12px 0',
                fontWeight: 600,
                fontSize: 15,
                flex: 1,
                cursor: 'pointer'
              }}
              onClick={() => window.open('https://wa.me/97450008852', '_blank')}
            >
              Contact Support
            </button>
            <button
              style={{
                background: '#f4f4f4',
                color: '#222',
                border: 'none',
                borderRadius: 8,
                padding: '12px 0',
                fontWeight: 600,
                fontSize: 15,
                flex: 1,
                cursor: 'pointer'
              }}
              onClick={() => navigate('/')}
            >
              Back to Home
            </button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PaymentErrorPage; 